import { initializeApp } from "firebase/app"
import { getDatabase } from "firebase/database" // for form db
import { getFirestore } from "firebase/firestore" // for form db
import { getAuth, GoogleAuthProvider } from "firebase/auth" // for auth/google provider
import { getAnalytics } from "firebase/analytics"
import { logEvent } from "firebase/analytics"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const db = getDatabase(app) // for form db
export const dbReview = getFirestore(app) // for form db
export const auth = getAuth(app) // for auth
export const provider = new GoogleAuthProvider() // google auth

logEvent(analytics, "notification_received")
logEvent(analytics, "user_gotIn")
